<template>
  <div>
    <div class="complex-wrap">
      <div class="complex-list">
        <div v-for="child in childrenUIs" class="complex-item" :key="child.name">
          <el-form-item :prop="child.name" :rules="child.rules">
            <component
              :is="child.component.component"
              :ref="child.name"
              :props="{ ...child.component.props, placeholder: child.label }"
            ></component>
          </el-form-item>
        </div>
        <div style="font-size: 12px; color: #999">{{ proTitleLength }}/30</div>
      </div>
      <div><el-button type="text" @click="clearAll">一键清空</el-button></div>
    </div>
    <div>标题预览： {{ proTitle }}</div>
    <div class="tips ft-12">
      <span>
        导购标题将在搜索、推荐、详情、购物车等场景展示，不影响搜索排序，请按照建议结构客观准确描述商品信息，若违规使用该产品造成消费者误解等不当影响的，店铺可能被限制使用该功能。
        <a href="https://www.yuque.com/zkzo1k/thyzgp/qeyonknqis7s2b8t" target="_blank">了解更多</a>
      </span>
    </div>
  </div>
</template>

<script>
import storeMixins from '../store-mixins';
import { checkLength } from '../../utils/index';

export default {
  mixins: [storeMixins],
  props: ['props'],
  data() {
    return {};
  },
  computed: {
    key() {
      return this.props.name;
    },
    childrenUIs() {
      return this.props.dataSource.children;
    },
    proTitle() {
      const valueList = this.childrenUIs.map(ui => {
        return this.tbForm[ui.name];
      });
      return valueList.join('');
    },
    proTitleLength() {
      return checkLength(this.proTitle);
    },
  },
  watch: {
    proTitle: {
      handler() {
        this.updateTbForm({
          [this.key]: this.proTitle,
        });
      },
      immediate: true,
    },
  },
  methods: {
    clearAll() {
      const values = {
        [this.Key]: '',
      };
      this.childrenUIs.map(ui => {
        values[ui.name] = '';
      });
      this.updateTbForm(values);
    },
  },
};
</script>

<style lang="scss" scoped>
.complex-wrap {
  padding: 10px 10px 0px;
  background: #f9f9fa;
}
.complex-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  position: relative;
  .complex-item {
    width: 120px;
    margin-bottom: 10px;
  }

  ::v-deep .el-form-item {
    position: relative;
    padding-right: 4px;
  }
}
</style>